var primary100 = '#ffd1cc'
var primary200 = '#fc8754'
var primary = '#FE5000'
var primary400 = '#e73c00'
var secondary100 = '#ab70a6'
var secondary200 = '#824578'
var secondary = '#59214D'
var secondary400 = '#30001f'
var tertiary100 = '#d6b5ed'
var tertiary200 = '#c9a6e0'
var tertiary = '#E1C9FCE5'
var tertiary400 = '#a382d6'
var success100 = '#d3ffdc'
var success200 = '#78b596'
var success = '#057863'
var success400 = '#002800'
var error100 = '#ffd6e5'
var error200 = '#ff91ad'
var error = '#F74259'
var error400 = '#e02652'
var background100 = '#fff'
var background200 = '#f8f9fa'
var background = '#F8F7FC'
var background400 = '#ececec'
var dark100 = '#B1ADC0'
var dark200 = '#64626C'
var dark = '#38363D'
var dark400 = '#242327'

var alpha = '1A'

const defaultTheme = {
  primaryColour: primary,
  primaryTextColour: dark,
  primaryHeaderColour: dark400,
  secondaryTextColour: dark100,
  backgroundColour: background200,
  formControlBorderRadius: '8px',
  formControlHorizontalPadding: '10px',
  formControlBottomMargin: '16px',
  generalFontSize: '16px',
  formControlHeight: '45px', // TODO: deprecate
  formControlValidIcon: {
    colour: background100,
    backgroundColour: dark,
  },
  radioFieldbackground: secondary,
  fontFamily: 'Indivisible',
  priceFontFamily: 'RL Aqva Black',
  priceFontColour: dark400,
  secondaryFontFamily: 'Indivisible',
  LegalDecsfontFamily: 'Indivisible',
  fontStyle: 'normal',
  inputFontFamily: 'Indivisible',
  fontWeight: '400',
  labelFontSize: '14px',
  largeHeaderFontSize: '40px',
  mobileLabelFontSize: '12px',
  labelTextColour: '#000000',
  headerFontFamily: 'Indivisible',
  headerFontColour: dark400,
  labelFontFamily: 'Indivisible',
  labelFontWeight: 600,
  numberPlateFontFamily: 'Purista',
  disabledButtonColour: '#d2d2d2',
  linkFontSize: '12px',
  linkColour: dark,
  linkFocusOutlineColour: primary,
  linkUnderline: dark,
  errorBackgroundColour: '#FFEDE8',
  infoBackgroundColour: '#5bc0de',
  errorBorderProperties: '2px solid ' + primary,
  errorColour: error,
  infoBorderProperties: '2px solid ' + dark100,
  errorIconColour: primary,
  infoIconColour: primary,
  messageBorderRadius: '6px',
  vehicleDetailBorderRadius: '16px',
  regFont: 'Purista',
  regColour: dark200,
  validIcon: '\f00c',
  secondaryColour: secondary,
  successColour: '#779E00',
  inputBorderColour: dark100,
  inputHoverOutlineColour: '#F3F4F6',
  inputFocusOutlineColour: primary100,
  inputFocusBorderColour: primary,
  inputActiveBorderColour: primary,
  inputActiveFocusOutlineColour: primary,
  secondaryInputFocusOutlineColour: secondary100,
  secondaryInputFocusBorderColour: secondary,
  message: {
    backgroundColor: background100,
    borderProperties: '2px solid ' + primary,
    error: {
      colour: error,
    },
    warn: {
      colour: primary,
    },
    info: {
      colour: success,
    },
  },
  icons: {
    border: '1px solid ' + dark100,
    height: '0px',
    width: '0px',
  },
  discountBanner: {
    error: {
      background: error,
      colour: background,
    },
    success: {
      background: success,
      colour: background,
    },
    warn: {
      background: primary,
      colour: background,
    },
  },
  multiPrice: {
    fontSize: '16px',
    mobile: {
      coverTypeFontSize: '12px',
      mobileCoverTypeFontSize: '12px',
      lowestPriceBannerFontSize: '12px',
      continueButtonFontSize: '22px',
    },
    continueButtonFontSize: '22px',
    button: {
      backgroundColour: secondary,
      disabledFont: background100,
    },
  },
  radioButton: {
    activeColor: background100,
    nonActiveColor: dark100,
  },
  card: {
    background: background100,
    border: '1px solid ' + background400,
    borderRadius: '16px',
    boxShadow: '0px 9px 15px 0px rgba(0, 0, 0, 0.05)',
  },
  button: {
    borderRadius: '8px',
    fontFamily: 'Indivisible',
    textTransform: 'inherit',
    fontWeight: 700,
    textAlign: 'center',
    hover: 'none',
    primary: {
      activeFocusOutlineColour: primary100,
      activeOutlineColour: '#F3F4F6',
      activeBackgroundColour: primary400,
      backgroundColour: primary,
      borderColour: 'transparent',
      boxShadowColour: 'rgba(251, 85, 4, 0.10)',
      colour: background100,
      disabledBackground: dark200,
      disabledColour: background100,
      focusBorderColour: primary,
      hoverBoxShadowColour: 'rgba(251, 85, 4, 0.20)',
      hoverBorderColour: primary,
      outlineColour: primary,
    },
    secondary: {
      activeFocusOutlineColour: secondary100,
      activeOutlineColour: '#F3F4F6',
      activeBackgroundColour: secondary400,
      backgroundColour: secondary,
      borderColour: 'transparent',
      boxShadowColour: 'rgba(79, 47, 79, 0.10)',
      colour: background100,
      disabledBackground: dark200,
      disabledColour: background100,
      focusBorderColour: secondary,
      hoverBoxShadowColour: 'rgba(79, 47, 79, 0.20)',
      hoverBorderColour: secondary,
      outlineColour: secondary,
    },
    line: {
      activeFocusOutlineColour: secondary100,
      activeOutlineColour: '#F3F4F6',
      activeBackgroundColour: background,
      backgroundColour: background100,
      borderColour: dark100,
      boxShadowColour: 'rgba(251, 85, 4, 0.10)',
      colour: dark200,
      disabledBackground: dark200,
      disabledColour: background100,
      focusBorderColour: secondary,
      hoverBoxShadowColour: 'rgba(251, 85, 4, 0.20)',
      hoverBorderColour: primary,
      outlineColour: primary,
    },
  },
  secondaryButton: {
    backgroundColour: secondary,
    borderColour: dark100,
  },
  toggleSwitch: {
    colour: background400,
    activeColour: dark100,
    checkedColour: primary,
    checkedActiveColour: primary400,
    thumbColour: secondary,
    thumbBorderColour: background100,
  },
  toggleButton: {
    primary: {
      colour: dark200,
      borderColour: dark100,
      backgroundColour: background100,
      activeColour: primary,
      activeBorderColour: primary,
      activeBackgroundColour: primary100,
      hoverFocusColour: primary,
      hoverFocusBorderColour: primary,
      hoverFocusBackgroundColour: background100,
      checkedColour: background100,
      checkedBorderColour: primary,
      checkedBackgroundColour: primary,
    },
    secondary: {
      colour: dark200,
      borderColor: dark100,
      backgroundColour: background100,
      activeColour: background100,
      activeBorderColour: secondary,
      activeBackgroundColour: secondary100,
      hoverFocusColour: secondary,
      hoverFocusBorderColour: secondary,
      hoverFocusBackgroundColour: background100,
      checkedColour: background100,
      checkedBorderColour: secondary,
      checkedBackgroundColour: secondary,
    },
  },

  progressionStep: {
    titleDesktopFontSize: '20px',
    titleFontSize: '18px',
    contentDesktopFontSize: '14px',
    contentFontSize: '12px',
    subContentFontSize: '10px',
    subContentExtraSmallFontSize: '8px',
    subContentIconDesktopSize: '15px',
    subContentIconSize: '15px',
  },
  GbIcon: dark,
  marketingPreferencesColour: primary,
  icon: {
    color: dark,
    backgroundColor: background100,
  },

  editIconColour: '#CCC',

  breadcrumb: {
    defaultBarColour: '#D9D9D9',
    completeBarColour: primary,

    defaultBorderColour: dark100,
    activeBorderColour: primary,
    completeBorderColour: primary,

    defaultBackgroundColour: background100,
    activeBackgroundColour: background100,
    completeBackgroundColour: primary400,

    defaultTextColour: dark100,
    activeTextColour: primary,
    completeTextColour: background100,

    focusBorderColour: primary,
  },

  priceComparison: {
    textColour: '#264694',
    headerColour: '#264694',
  },
  spinner: {
    primaryColour: dark,
    textColour: dark,
  },
  drivingLicence: {
    primaryColour: primary,
  },
  durationOptions: {
    primaryColour: dark100,
    secondaryColour: '#779E00',
    durationButtonForeColour: background100,
  },
  header: {
    background: background200,
    borderBottom: '1px solid #B1ADC0',
    backgroundImage: '',
  },
  headerLinkStyled: {
    textColour: dark,
    background: background100,
    padding: '16px',
    hover: {
      textDecoration: 'underline',
      color: background100,
      backgroundColour: primary,
      padding: '0px',
    },
  },
  gradient: {
    startColour: background100,
    background: '#F3F8FF',
  },
  svg: {
    primaryColour: primary,
    accentColour: '#ccdcff',
  },
  trustpilot: {
    background: primary,
  },
}

export default defaultTheme
